module.exports = __webpack_public_path__ + "static/media/ddw.83fe1ffb.png";